/* HALO — global cart drawer. Opens on add-to-cart (with an optimistic line so
   it never flashes empty) and from the header cart icon. Renders lines from
   /cart.js, supports qty change / remove, slim rotating reassurance strip.
   The footer is a real cart <form> so Checkout + Shopify express wallets work.
   Exposes window.HaloCart. */
(function () {
  var cd = document.querySelector('[data-cd]');
  if (!cd) return;

  var linesEl = cd.querySelector('[data-cd-lines]');
  var emptyEl = cd.querySelector('[data-cd-empty]');
  var loadingEl = cd.querySelector('[data-cd-loading]');
  var footEl = cd.querySelector('[data-cd-foot]');
  var subtotalEl = cd.querySelector('[data-cd-subtotal]');
  var headCountEl = cd.querySelector('[data-cd-headcount]');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function money(cents, cur) {
    var whole = cents % 100 === 0; // premium pricing reads clean: $200, never $200.00
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency', currency: cur || 'USD',
        minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: whole ? 0 : 2
      }).format(cents / 100);
    } catch (e) { return '$' + (whole ? (cents / 100) : (cents / 100).toFixed(2)); }
  }
  function imgUrl(src, w) { if (!src) return ''; return src.indexOf('?') > -1 ? src + '&width=' + w : src + '?width=' + w; }

  /* ---------- open / close ---------- */
  function open() {
    cd.hidden = false; cd.setAttribute('aria-hidden', 'false');
    requestAnimationFrame(function () { requestAnimationFrame(function () { cd.classList.add('is-open'); }); });
    document.documentElement.style.overflow = 'hidden';
    startStrip();
  }
  function close() {
    cd.classList.remove('is-open'); cd.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    stopStrip();
    setTimeout(function () { cd.hidden = true; }, reduce ? 0 : 560);
  }

  /* ---------- render ---------- */
  function setHeaderCount(n) {
    document.querySelectorAll('.halo-cart').forEach(function (cart) {
      var badge = cart.querySelector('.halo-cart__count');
      if (!badge && n > 0) { badge = document.createElement('span'); badge.className = 'halo-cart__count'; cart.appendChild(badge); }
      if (badge) { badge.textContent = n; badge.style.display = n > 0 ? '' : 'none'; }
    });
    if (headCountEl) headCountEl.textContent = n > 0 ? '(' + n + ')' : '';
  }

  function lineHTML(item, ghost) {
    var variant = '';
    if (item.variant_title && item.variant_title !== 'Default Title') variant = item.variant_title;
    var img = item.image ? '<img src="' + imgUrl(item.image, 160) + '" alt="' + esc(item.product_title) + '" loading="lazy">' : '';
    var url = item.url || '#';
    return '' +
      '<li class="cd__line' + (ghost ? ' is-ghost' : '') + '" data-key="' + esc(item.key || '') + '">' +
        '<a class="cd__line__media" href="' + esc(url) + '">' + img + '</a>' +
        '<div class="cd__line__info">' +
          '<a class="cd__line__title" href="' + esc(url) + '">' + esc(item.product_title) + '</a>' +
          (variant ? '<span class="cd__line__variant">' + esc(variant) + '</span>' : '') +
          '<div class="cd__qty">' +
            '<button type="button" data-cd-dec aria-label="Decrease quantity"' + (ghost ? ' disabled' : '') + '>&minus;</button>' +
            '<span>' + item.quantity + '</span>' +
            '<button type="button" data-cd-inc aria-label="Increase quantity"' + (ghost ? ' disabled' : '') + '>+</button>' +
          '</div>' +
        '</div>' +
        '<div class="cd__line__right">' +
          '<span class="cd__line__price">' + money(item.final_line_price, item.currency) + '</span>' +
          (ghost ? '' : '<button type="button" class="cd__line__remove" data-cd-remove>Remove</button>') +
        '</div>' +
      '</li>';
  }

  function render(cart) {
    if (loadingEl) loadingEl.hidden = true;
    var cur = cart.currency;
    setHeaderCount(cart.item_count);
    if (!cart.items || !cart.items.length) {
      linesEl.innerHTML = '';
      if (emptyEl) emptyEl.hidden = false;
      if (footEl) footEl.hidden = true;
      return;
    }
    if (emptyEl) emptyEl.hidden = true;
    if (footEl) footEl.hidden = false;
    if (subtotalEl) subtotalEl.textContent = money(cart.items_subtotal_price != null ? cart.items_subtotal_price : cart.total_price, cur);
    linesEl.innerHTML = cart.items.map(function (item) {
      item.currency = cur;
      return lineHTML(item, false);
    }).join('');
  }

  /* Optimistic line — shown the instant the drawer opens from add-to-cart,
     replaced by the real render as soon as /cart.js responds. */
  function optimistic(item) {
    if (loadingEl) loadingEl.hidden = true;
    if (emptyEl) emptyEl.hidden = true;
    var existing = linesEl.children.length;
    if (!existing) {
      linesEl.innerHTML = lineHTML({
        product_title: item.title, image: item.image, url: item.url,
        quantity: 1, final_line_price: item.priceCents, currency: item.currency
      }, true);
      if (footEl) footEl.hidden = false;
      if (subtotalEl) subtotalEl.textContent = money(item.priceCents, item.currency);
    } else {
      // item already visible — just pulse the first matching line while the real state lands
      var first = linesEl.querySelector('.cd__line');
      if (first) first.classList.add('is-ghost');
    }
  }

  function refresh() {
    if (!linesEl.children.length && loadingEl) loadingEl.hidden = false;
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(render)
      .catch(function () {
        if (loadingEl) loadingEl.hidden = true;
        // never leave an optimistic ghost line pulsing on a failed sync
        linesEl.querySelectorAll('.is-ghost').forEach(function (el) { el.classList.remove('is-ghost'); });
      });
  }

  /* Quantity writes are serialised. Rapid taps used to each read the same stale
     DOM quantity and post the same value (3 taps on "+" from 1 → 2, not 4), and
     out-of-order responses could repaint a stale cart. We track the intended
     quantity per line key and queue requests behind the in-flight one. */
  var pending = {};   // key -> quantity we intend the line to end at
  var inFlight = null;

  function flush() {
    if (inFlight) return;
    var key = Object.keys(pending)[0];
    if (!key) return;
    var qty = pending[key];
    delete pending[key];
    inFlight = fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(render)
      .catch(function () { return refresh(); })
      .then(function () { inFlight = null; flush(); });
  }

  function changeQty(key, qty) {
    pending[key] = Math.max(0, qty);
    flush();
  }

  /* Reads the intended quantity (queued value if one is pending) so repeat taps
     compound instead of collapsing onto the same stale number. */
  function intendedQty(key, li) {
    if (Object.prototype.hasOwnProperty.call(pending, key)) return pending[key];
    var qtyEl = li.querySelector('.cd__qty span');
    return qtyEl ? parseInt(qtyEl.textContent, 10) || 0 : 1;
  }

  /* line item events (delegated) */
  linesEl.addEventListener('click', function (e) {
    var li = e.target.closest('.cd__line'); if (!li) return;
    var key = li.getAttribute('data-key'); if (!key) return;
    var q = intendedQty(key, li);
    if (e.target.closest('[data-cd-inc]')) changeQty(key, q + 1);
    else if (e.target.closest('[data-cd-dec]')) { if (q > 0) changeQty(key, q - 1); }
    else if (e.target.closest('[data-cd-remove]')) changeQty(key, 0);
  });

  /* ---------- reassurance strip ---------- */
  var btrack = cd.querySelector('[data-cd-btrack]');
  var bn = btrack ? btrack.children.length : 0;
  var bi = 0, btimer = null;
  function bgo(n) {
    if (!bn) return;               /* no slides → avoid a NaN transform */
    bi = (n % bn + bn) % bn;
    if (btrack) btrack.style.transform = 'translateX(-' + (bi * 100) + '%)';
  }
  function startStrip() { if (reduce || bn < 2) return; stopStrip(); btimer = setInterval(function () { bgo(bi + 1); }, 5600); }
  function stopStrip() { if (btimer) { clearInterval(btimer); btimer = null; } }
  var bprev = cd.querySelector('[data-cd-bprev]'), bnext = cd.querySelector('[data-cd-bnext]');
  if (bprev) bprev.addEventListener('click', function () { bgo(bi - 1); startStrip(); });
  if (bnext) bnext.addEventListener('click', function () { bgo(bi + 1); startStrip(); });

  /* ---------- wiring ---------- */
  cd.querySelectorAll('[data-cd-close]').forEach(function (el) { el.addEventListener('click', close); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !cd.hidden) close(); });

  // Header cart icon(s) open the drawer instead of navigating to /cart.
  // Re-bound on section:load so the drawer still works after a theme-editor
  // header re-render (which replaces the .halo-cart nodes we bound to).
  function bindCartIcons() {
    document.querySelectorAll('.halo-cart').forEach(function (a) {
      if (a.__cdBound) return; a.__cdBound = true;
      a.addEventListener('click', function (e) { e.preventDefault(); openWithRefresh(); });
    });
  }
  bindCartIcons();
  document.addEventListener('shopify:section:load', bindCartIcons);

  function openWithRefresh() { open(); refresh(); }

  window.HaloCart = {
    open: open,
    close: close,
    refresh: refresh,
    openWithRefresh: openWithRefresh,
    optimistic: optimistic,
    render: render
  };
})();
